import { compose, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import { formValueSelector, reduxForm } from 'redux-form';
import { injectIntl } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';
import _ from 'lodash';

import {
  AvailableFeaturesForm,
  ConfigurationPageForm,
  MessageFrequencyCapping,
} from '../../constants';
import journeyStatusEnums from '../../../../Enums/journeyStatus';
import MessageCappingConfigurationPage from './MessageCappingConfigurationPage';

const styles = {
  configurationPageWrapper: {
    flexGrow: 1,
    padding: '0 16px 16px',
  },
};

export const mapStateToProps = state => {
  const { periods } = state.journeyBuilderUIDataArea.timePeriods;
  const { channels } = state.journeyBuilderUIDataArea.channels;
  const { value, hasValue } = state.journeyBuilderUIDataArea.limits;
  const availableFeatureselector = formValueSelector(AvailableFeaturesForm);
  const activityType = availableFeatureselector(state, 'activityType');
  const selector = formValueSelector(ConfigurationPageForm);
  const channel = selector(state, 'channel');
  const timePeriod = selector(state, 'timePeriod');

  const args = state.journeyBuilderConfigurationArea.activity.arguments;
  const journeyStatus = state.journeyBuilderConfigurationArea.interaction.status;
  const status =
    journeyStatus === journeyStatusEnums.DRAFT || journeyStatus === journeyStatusEnums.PAUSED
      ? false
      : true;

  const initialValues = {};
  if (!_.isEmpty(channel) && !_.isEmpty(timePeriod)) {
    initialValues.timePeriod = timePeriod;
    initialValues.channel = channel;
  } else if (
    args.execute.inArguments.length > 0 &&
    args.execute.inArguments[0].timePeriod &&
    args.execute.inArguments[0].channelCode
  ) {
    initialValues.timePeriod = args.execute.inArguments[0].timePeriod;
    initialValues.channel = args.execute.inArguments[0].channelCode;
  } else if (periods.length > 0 && channels.length > 0) {
    initialValues.timePeriod = periods[0].value;
    initialValues.channel = channels[0].channelCode;
  }

  const data = {
    periods,
    channels,
    hasValue,
    channel,
    timePeriod,
    initialValues,
    activityType,
    status,
  };

  if (channel && timePeriod) {
    const limitValue = value.find(e => e.channelCode === channel);
    if (limitValue) {
      const limitTime = limitValue[timePeriod.toLowerCase()];
      data.limitTime = limitTime;
    }
  }

  return data;
};

export const enhance = lifecycle({
  componentWillUpdate(nextProps) {
    if (nextProps.activityType !== this.props.activityType) {
      if (
        _.includes(this.props.activityType, MessageFrequencyCapping) &&
        !_.includes(nextProps.activityType, MessageFrequencyCapping)
      ) {
        this.props.change('channel', this.props.channels[0].channelCode);
        this.props.change('timePeriod', this.props.periods[0].value);
      }
    }
  },
})(MessageCappingConfigurationPage);

export default compose(
  connect(mapStateToProps),
  reduxForm({
    form: ConfigurationPageForm,
    enableReinitialize: true,
    destroyOnUnmount: false,
  }),
  injectIntl,
  withStyles(styles, { name: 'MessageCappingConfigurationPage' })
)(enhance);



// WEBPACK FOOTER //
// ./src/JourneyBuilder/SendOptimizer/components/MessageCappingConfigurationPage/index.js